/**
 * Prefix url input
 *
 * @param {string} url User input url
 * @returns {string} Prefixed user input url
 */
export default (url) => -1 < url.indexOf('http') ? url : `https://${url}`;
